var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"bottom":"","inset":"","color":_vm.returnColor(),"dark":"","app":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v("Copyright © 2022 QQPay SDN BHD. All rights reserved")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }